import axiosClient from "./axiosClient";
import { collectCatalogPages } from "./catalogApi";

const unwrap = response => response.data?.payload ?? response.data?.data ?? response.data;
const quiet = { __silentGenericToast: true };
// Unlike the operational list, setup must find existing configuration on every page.
export const listSetupEntities = kind => collectCatalogPages(async params =>
  unwrap(await axiosClient.get(`/scheduling/${kind}`, { params, ...quiet })));
export const testSetupAvailability = params => axiosClient.get("/scheduling/availability", {
  params, ...quiet,
}).then(unwrap);
